import React from 'react';

const AboutBB = () => {
    return (
        <div className="bg-[#f4f4f4] text-black py-3 px-6 text-center" >
            <h1 className="text-5xl md:text-6xl font-bold mb-10" style={{ fontFamily: ' Anonymous Pro , sans-serif' }}>Sobre a Breach Busters</h1>
            <p className="max-w-2xl mx-auto mb-8 leading-relaxed text-lg md:text-xl" style={{ fontFamily: ' Montserrat , sans-serif' }}>
                A Breach Busters é uma empresa de tecnologia brasileira focada no segmento de segurança ofensiva,
                com profissionais relevantes e certificados na área e apaixonados pelo que fazem.
            </p>
            <p className="max-w-2xl mx-auto mb-8 leading-relaxed text-lg md:text-xl" style={{ fontFamily: ' Montserrat , sans-serif' }}>
                A experiência e nossa jornada nos coloca em um patamar de excelência, os desafios fazem nos fazem
                mais fortes e engradece nossa qualidade. Temos como objetivo elevar o nível de segurança das
                empresas latina americanas.
            </p>
            <p className="max-w-2xl mx-auto mb-8 leading-relaxed text-lg md:text-xl" style={{ fontFamily: ' Montserrat , sans-serif' }}>
                Hoje a Breach Busters consegue realizar tais feitos com maestria com todos os clientes sempre seguindo sua
                missão: Fortalecer a segurança dos nossos clientes diante de quaisquer desafios.
            </p>
        </div>
    );
}

export default AboutBB;
